import type React from 'react'
import { useSelector } from 'react-redux'

import type { AppState } from '@/types'
import css from './Placeholder.module.scss'

type Props = {
  onLogin: () => void
}

export const CommentsPlaceholder: React.FC<Props> = ({ onLogin }) => {
  const isEmbed = useSelector<AppState, boolean>(
    ({ artboard }) => artboard.isEmbed
  )

  if (isEmbed) {
    return null
  }

  return (
    <div className={css.placeholder}>
      <div className={css.action} onClick={onLogin}>
        <svg
          width="17"
          height="17"
          viewBox="0 0 17 17"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M8.5 12.9453C8.73438 12.9453 8.91016 12.8867 9.08594 12.7109C9.23242 12.5645 9.32031 12.3594 9.32031 12.125V10.25C9.32031 10.0156 9.23242 9.83984 9.08594 9.66406C8.91016 9.51758 8.73438 9.42969 8.5 9.42969C8.26562 9.42969 8.06055 9.51758 7.91406 9.66406C7.73828 9.83984 7.67969 10.0156 7.67969 10.25V12.125C7.67969 12.3594 7.73828 12.5645 7.91406 12.7109C8.06055 12.8867 8.26562 12.9453 8.5 12.9453ZM15.0625 7.90625C15.0625 7.52539 14.916 7.20312 14.6523 6.91016C14.3594 6.64648 14.0371 6.5 13.6562 6.5H12.7188V5.12305C12.7188 4.36133 12.5137 3.6582 12.1328 3.01367C11.752 2.36914 11.2539 1.8418 10.6094 1.46094C9.96484 1.08008 9.26172 0.875 8.5 0.875C7.73828 0.875 7.03516 1.08008 6.39062 1.46094C5.74609 1.8418 5.21875 2.33984 4.83789 2.98438C4.45703 3.62891 4.28125 4.33203 4.28125 5.09375V6.5H3.34375C2.93359 6.5 2.61133 6.64648 2.34766 6.91016C2.05469 7.20312 1.9375 7.52539 1.9375 7.90625V14.4688C1.9375 14.8789 2.05469 15.2012 2.34766 15.4648C2.61133 15.7578 2.93359 15.875 3.34375 15.875H13.6562C14.0371 15.875 14.3594 15.7578 14.6523 15.4648C14.916 15.2012 15.0625 14.8789 15.0625 14.4688V7.90625ZM5.6875 6.5V5.09375C5.6875 4.33203 5.95117 3.6582 6.50781 3.10156C7.03516 2.57422 7.70898 2.28125 8.5 2.28125C9.26172 2.28125 9.93555 2.57422 10.4922 3.10156C11.0195 3.6582 11.3125 4.33203 11.3125 5.09375V6.5H5.6875ZM13.6562 7.90625V14.4688H3.34375V7.90625H13.6562Z"
            fill="#2F7FEF"
          />
        </svg>
        Log in
      </div>

      <div className={css.text}>to view or add comments</div>
    </div>
  )
}
